export default __webpack_public_path__ + "static/media/chemistry.658794dd.svg";